import axios from "axios";
import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import AccessDenied from "./AccessDenied";
import HorizontalLayout from "../components/HorizontalLayout/";
import Loader from "pages/Separate/Loader";
import configure from "configure";
import { useSelector } from "react-redux";
import { getPermissionsByModule, hasIndiaPermission } from "utils/common-helpers";

const Authenticate = props => {
  const [roles, setRole] = useState([]);
  const [loading, setLoading] = useState(true);
  const role = useSelector((state) => state?.Roles?.apiData)
  useEffect(() => {
    const fetchRoles = async () => {
      try {
        setLoading(true)
        const permission = getPermissionsByModule(role, props.module)
        setRole([permission]);
        setLoading(false);

      } catch (err) {
      } finally {
        setLoading(false);
      }
    };

    fetchRoles();
  }, [props.module]);
  const indiaPermissions = roles[0]?.india || [];
  const ukPermissions = roles[0]?.uk || [];

  const hasIndiaPermission = index =>
    indiaPermissions[index] != undefined && indiaPermissions[index] == 1;
  const hasUkPermission = index =>
    ukPermissions[index] != undefined && ukPermissions[index] == 1;
  const hasPermission =
    (props.type === "view" && (hasIndiaPermission(2) || hasUkPermission(2))) ||
    (props.type === "add" && (hasIndiaPermission(3) || hasUkPermission(3))) ||
    (props.type === "edit" && (hasIndiaPermission(4) || hasUkPermission(4)));
  if (loading) {
    return (
      <HorizontalLayout>
        <Loader />
      </HorizontalLayout>
    );
  }

  if (hasPermission) {
    return <React.Fragment>{props.children}</React.Fragment>;
  } else {
    return (
      <Navigate
        to={{
          pathname: `${configure.appUrl}access-denied`,
          state: { from: props.location },
        }}
      />
    );
  }
};

export default Authenticate;
